import Http from "./chatapp-http";

class ChatMessenger extends Http {
  createChat(variables) {
    return this.create('create',variables);
  }
  getConversations(){
    return this.client.get('/list')
  }
  joinChatRoom(chatRoomId) {
    return this.client.post(`join/chatroom/${chatRoomId}`, {})
  }
  loadMessages(chatRoomId, lastMessage) {
    return this.client.get(`messages/${chatRoomId}?lastMessage=${lastMessage}`)
  }
  deleteChatHistory(chatRoomId) {
    return this.client.delete(`delete/${chatRoomId}`)
  }
  getChatRoomMessages(chatRoomId){
    return this.client.get(`${chatRoomId}/messages?inverted=no`)
  }
}
const chatMessengerObj = new ChatMessenger({
  modelUrlPrefix : "chat",
  timeout        : 60000
});

export default chatMessengerObj;